import { useCallback, useEffect, useState } from "react";
import { SpaceModel } from "../interfaces/Space";

const MAX_WAYPOINTS = 9;

//TODO: refactor toggle logic because it seems overdone
//Toggle was propagated to Change type and addToRoute because 
//route state was not updating outside setter function (no the hook state)
//We must look at the state inside its setter function, i.e.: setRoute((r)=>{})
//route state just isn't updated for some reason, even though it is updating outside the hook (exported members)
//maybe a bug? No fucking idea

export type Change = {
  kind: 'add' | 'remove',
  space: SpaceModel
  toggle?: boolean
}
type Props = {
  spaceList: SpaceModel[];
}

export default function UseRoute({ spaceList }: Props) {
  const [route, setRoute] = useState<SpaceModel[]>([]);
  const [changes, setChanges] = useState<Change[]>([]);
  const [subtractedList, setSubtractedList] = useState<SpaceModel[]>(spaceList);

  const addSpace = useCallback((space: SpaceModel, toggle?: boolean) => {
    setChanges((c) => [...c, { kind: 'add', space, toggle }])
  }, [])

  const removeSpace = useCallback((space: SpaceModel) => {
    setChanges((c) => [...c, { kind: 'remove', space }])
  }, [])


  const toggleSpace = useCallback((space: SpaceModel) => {
    addSpace(space, true);
  }, [addSpace])

  useEffect(() => {
    setSubtractedList(spaceList)
  }, [spaceList])

  const addToRoute = useCallback((space: SpaceModel, toggle?: boolean) => {
    if (route.length >= MAX_WAYPOINTS) return;
    setRoute((route) => {
      if (toggle && route.find((s) => space.id === s.id)) {
        return route.filter((s) => s.id !== space.id);
      } else {
        return [...route, space];
      }
    });

    setSubtractedList((sl) => {
      if (toggle && !subtractedList.find((s) => s.id === space.id)) {
        return [...subtractedList, space]
      } else {
        return sl.filter((s) => s.id !== space.id);
      }

    });
  }, [route, subtractedList]);

  const removeFromRoute = useCallback((space: SpaceModel) => {
    setRoute((route) => route.filter((f) => f.id !== space.id));
    setSubtractedList((sl) => [...sl, space]);
  }, []);

  useEffect(() => {
    const latest = changes.pop();
    if (latest) {
      switch (latest.kind) {
        case 'add': addToRoute(latest.space, latest.toggle); break;
        case 'remove': removeFromRoute(latest.space); break;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changes]);

  //clean changes array every 10 seconds because it can become quite big...
  useEffect(() => {
    setInterval(() => {
      changes.length > 0 && setChanges([]);
    }, 10000);
  }, [changes]);


  const clearRoute = useCallback(() => {
    setSubtractedList(spaceList);
    setRoute([]);
  }, [spaceList]);

  return { route, subtractedList, addSpace, removeSpace, toggleSpace, clearRoute, setRoute };
}
